import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import { bindActionCreators } from 'redux'
import { StyledAddress, StyledUndo } from './styles/address.style'
import { toastActions } from '../../../actions'

class Address extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isRemoving: false,
			isFading: false,
			timeOutToRemove: null
		}
	}

	handleRemove = () => {
		this.setState({
			isRemoving: true,
			timeOutToRemove: setTimeout(() => {
				this.remove()
			}, 2000)
		})
	}

	undoRemoving = () => {
		this.setState({
			isRemoving: false,
			isFading: false,
			timeOutToRemove: clearTimeout(this.state.timeOutToRemove)
		})
	}

	remove = () => {
		this.setState({ isFading: true }, () => {
			setTimeout(() => {
				this.setState({ isRemoving: false, isFading: false }, () => {
					this.props.onRemove()
				})
			}, 150)
		})
	}

	render() {
		const { address, onSelect, onEdit, danger } = this.props
		const { isRemoving, isFading } = this.state

		return (
			<StyledAddress
				isActive={address.billingAddress}
				className={`animated ${isFading ? 'fadeIn' : ''}`}>
				{isRemoving ? (
					<StyledUndo className="undo bold" onClick={this.undoRemoving}>
						Desfazer
					</StyledUndo>
				) : (
					<Fragment>
						{isIncompleteAddress(address) ? (
							<IncompleteAddress onClick={onSelect} {...address} />
						) : (
							<CompleteAddress onClick={onSelect} {...address} />
						)}
						<div className="controls">
							<FontAwesome
								name="pencil"
								onClick={onEdit}
								title="Editar endereço"
							/>
							<FontAwesome
								name="trash"
								onClick={
									address.billingAddress
										? () =>
												danger({
													message:
														'Não é possível excluir um endereço de cobrança'
												})
										: this.handleRemove
								}
								title="Excluir endereço"
							/>
						</div>
					</Fragment>
				)}
			</StyledAddress>
		)
	}
}

const isIncompleteAddress = ({ street, number, neighborhood, zipCode }) =>
	[street, number, neighborhood, zipCode].some(value => value === null)

const CompleteAddress = ({
	onClick,
	street,
	number,
	complement,
	neighborhood,
	city,
	state,
	zipCode
}) => (
	<div
		className="address"
		title="Escolher como endereço de cobrança"
		onClick={onClick}>
		<span className="bold">{street}</span> <br />
		N° {number} {complement} <br />
		{neighborhood} <br />
		{city} - {state} <br />
		CEP {zipCode} <br />
	</div>
)

const IncompleteAddress = ({ onClick, city, state }) => (
	<div
		className="address"
		title="Escolher como endereço de cobrança"
		onClick={onClick}>
		<span className="bold">Informe o endereço completo</span> <br />
		{city} - {state}
	</div>
)

const mapDispatchToProps = dispatch =>
	bindActionCreators({ ...toastActions }, dispatch)

const ConnectedAddress = connect(
	null,
	mapDispatchToProps
)(Address)

export { ConnectedAddress as Address }
